<script setup>
const props = defineProps({
    opened: {
        type: Boolean,
        required: true,
    },
    classes: {
        type: String,
        required: false,
        default: '',
    },
    closeInside: {
        type: Boolean,
        required: false,
        default: false,
    },
});

// Emits
const emit = defineEmits(['close']);

// Events
const handleClose = () => {
    emit('close');
};
</script>

<template>
    <MessModal :opened="opened" @close="handleClose" :classes="classes">
        <template v-if="!closeInside" #close>
            <MessSvg type="x" />
        </template>
        <template #content>
            <div class="modal-content">
                <div v-if="closeInside" class="close-inside" @click="handleClose">
                    <MessSvg type="x" />
                </div>
                <slot @closeSearch="handleClose" />
            </div>
        </template>
    </MessModal>
</template>

<style lang="scss">
.mess-modal {
    background: var(--teal);
    padding: 6rem;
    display: flex;
    align-items: center;

    &.search-modal {
        .modal-content .close-inside {
            margin-bottom: 1.4rem;
        }

        .body {
            padding: 1.4rem 3.125rem 3.125rem;
            overflow: hidden;
        }

        svg {
            width: 1rem;
            height: 1rem;
        }
    }

    &.inner-close {
        .body {
            .close {
                display: none;
            }
        }
    }

    .body {
        @include styled-scrollbar;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: min(100%, 1360px);
        max-height: calc(90 * var(--vh));
        overflow-y: auto;

        .close {
            top: 0rem;
            right: -2.25rem;
            background: var(--orange);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem;
            color: white;
            border: 2px solid transparent;
            transform-origin: top center;
            transition: 300ms ease;

            .mess-svg {
                width: 1rem;
                height: 1rem;
            }

            &:hover,
            &:active,
            &:focus {
                scale: 0.85;
                border-color: white;
            }
        }
    }

    .modal-content {
        position: relative;

        .close-inside {
            cursor: pointer;
            margin-bottom: 3rem;
            display: flex;
            justify-content: flex-end;
            transition: 300ms ease;

            //mobile
            @media (max-width: $mobile) {
                margin-bottom: 1.5rem;
            }

            svg {
                transition: 300ms ease;

                &:hover {
                    transform: scale(1.1);
                }
            }
        }

        h2 {
            text-transform: none;
            color: var(--teal, #042729);
            font-family: 'Lexend Deca';
            font-size: 32px;
            font-style: normal;
            font-weight: 600;
            line-height: 125%;
            /* 40px */
            letter-spacing: -0.64px;
        }

        .modal-copy {
            margin-top: 1.5rem;
            color: var(--teal, #042729);
            font-style: normal;
            font-weight: 300;
            line-height: 27px;
            /* 158.824% */
            letter-spacing: 0.51px;

            a {
                color: var(--Cherry-Blossom-Dark, #cf1b57);
                font-style: normal;
                font-weight: 300;
                line-height: 27px;
                letter-spacing: 0.51px;
            }
        }

        .modal-alert {
            margin-top: 40px;
            display: flex;
            padding: 1.5rem;
            align-items: center;
            gap: 1.5rem;
            align-self: stretch;
            background: var(--Solaris-Light, #ffcec2);
            color: var(--teal, #042729);
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 0.4px;

            svg {
                min-width: 24px;
            }

            @media (max-width: $mobile) {
                margin-top: 2rem;

                padding: 1rem;
                gap: 1rem;
            }
        }

        .modal-action-buttons {
            display: flex;
            gap: 1.5rem;
            margin-top: 3rem;

            @media (max-width: $mobile) {
                flex-direction: column;
                gap: 1rem;
                margin-top: 2rem;

                button {
                    width: 100%;
                }
            }
        }
    }

    @media (max-width: $tablet) {
        padding: 1rem;

        .body {
            padding: 1.5rem;
            padding-top: 4rem;

            .close {
                right: 0;
                top: -2.35rem;
            }
        }
    }

    //mobile styles
    @media (max-width: 400px) {
        .body {
            padding-top: 2rem;
        }
    }
}
</style>
